import React, { Component } from 'react';
import * as Styles from './Styles';
import Term from './term/Term';
import Button from '../../../components/button/Button';
import Receipt from './receipt/Receipt';
import Sections from './sections/Sections';
import * as FormManager from '../../../reducers/ui/form';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../../core/Store';

type State = {};

class FormComponent extends Component<PropsFromRedux, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper>
				<Term />
				<Styles.ContentContainer>
					<Styles.ContentSectionsContainer>
						<Sections />
						<Styles.ReceiptRail>
							<Receipt />
						</Styles.ReceiptRail>
					</Styles.ContentSectionsContainer>
					<Styles.NextContainer>
						<Button
							Icon={Styles.NextButtonIcon}
							label="przechodzę do weryfikacji wniosku celem przystąpienia do ubezpieczenia"
							onClick={() => FormManager.promptNext()}
							style={Styles.getNextButtonStyle(
								!this.props.canOpenStage1Modal
							)}
						/>
					</Styles.NextContainer>
				</Styles.ContentContainer>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		canOpenStage1Modal: FormManager.Selectors.getCanOpenStage1Modal(state),
	}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Form = connector(FormComponent);
export default Form;
